const project = process.env.GOOGLE_CLOUD_PROJECT || 'duome-live'

const live = (project === 'duome-live')

const publicProfilesUrl = (live) ? 'https://duome.co' : `https://public-dot-${project}.appspot.com`
const appUrl = (live) ? 'https://jobshare.duome.co' : `https://${project}.firebaseapp.com`
const appName = project

module.exports = {
  publicProfilesUrl,
  appUrl,
  appName
}
